import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import PillButton from '../../ui/PillLink/PillButton';
import { useConsent } from '../../../consent/useConsent';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './CookieBanner.module.css';

export default function CookieBanner() {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();
    const { bannerOpen, settingsOpen, decision, acceptAll, rejectAll, save, openSettings } = useConsent();
    const [analyticsChecked, setAnalyticsChecked] = useState(false);

    useEffect(() => {
        setAnalyticsChecked(decision?.analytics ?? false);
    }, [decision, settingsOpen]);

    if (!bannerOpen) return null;

    return (
        <aside className={styles.banner} role="dialog" aria-labelledby="cookie-title" aria-describedby="cookie-text" data-theme="dark">
            <h2 id="cookie-title" className={styles.title}>{t('cookies.title')}</h2>
            <p id="cookie-text" className={styles.text}>
                <Trans
                    i18nKey="cookies.text"
                    components={{
                        privacy: <Link to={localizedPath('/privacy-policy')} />,
                        cookies: <Link to={localizedPath('/cookie-policy')} />
                    }}
                />
            </p>
            {settingsOpen && (
                <div className={styles.options}>
                    <div className={styles.option}>
                        <span className={styles.optionText}>
                            <span className={styles.optionLabel}>{t('cookies.essentialLabel')}</span>
                            <span className={styles.optionDetail}>{t('cookies.essentialDescription')}</span>
                        </span>
                        <span className={styles.always}>{t('cookies.always')}</span>
                    </div>
                    <label className={styles.option}>
                        <span className={styles.optionText}>
                            <span className={styles.optionLabel}>{t('cookies.analyticsLabel')}</span>
                            <span className={styles.optionDetail}>{t('cookies.analyticsDescription')}</span>
                        </span>
                        <input type="checkbox" className={styles.checkbox} checked={analyticsChecked} onChange={(event) => setAnalyticsChecked(event.target.checked)} />
                    </label>
                </div>
            )}
            <div className={styles.actions}>
                <PillButton variant="outline" onClick={rejectAll}>{t('cookies.reject')}</PillButton>
                {settingsOpen ? (
                    <PillButton variant="outline" onClick={() => save(analyticsChecked)}>{t('cookies.save')}</PillButton>
                ) : (
                    <PillButton variant="outline" onClick={acceptAll}>{t('cookies.accept')}</PillButton>
                )}
                {!settingsOpen && (
                    <button type="button" className={styles.settingsLink} onClick={openSettings}>{t('cookies.settings')}</button>
                )}
            </div>
        </aside>
    );
}
